module.exports = __webpack_public_path__ + "static/media/serieGD.c0e2fb22.pdf";